import { ITemplateData } from "@framework/types";
import { lineColors } from "../../../../scheme/components/analytics/constants";
import { IChartData } from "../../../../scheme/components/analytics/interfaces";

export function formatData<T, S extends keyof T>(dataForFormatting: T[], groupField: S): T[][] | T[] {
  const groups = [...new Set(dataForFormatting.map(item => item[groupField]))];

  if (groups.length > 1) {
    return groups.map(itemName => dataForFormatting.filter(item => item[groupField] === itemName));
  }

  return dataForFormatting;
}

export const formatChartData = (
  data: ITemplateData[] | ITemplateData[][],
  getLocal: (date: string) => string,
): IChartData | IChartData[] => {
  const formatItem = (itemData: ITemplateData[]): IChartData => {
    const points = itemData.map(item => ({
      date: item?.LayerName ? getLocal(item?.LayerName) : "",
      value: item?.Value,
    }));

    const colorItem = itemData[0].PaletteBackgroundColor ? +itemData[0].PaletteBackgroundColor : 1;

    return {
      color: lineColors[colorItem],
      items: points,
      name: itemData[0].ValueName ?? "",
      units: " ",
    };
  };

  if (data.length > 0 && Array.isArray(data[0])) {
    return data.map(item => formatItem(item as ITemplateData[]));
  }

  return formatItem(data as ITemplateData[]);
};
